import { MIN_POSITION } from '../constants';
import { clampPosition } from './clamp-position';

/**
 * Converts pointer clientX and the rail's bounding rect into a position in 0..100.
 * Used when the user clicks or taps the rail.
 */
export function calculatePosition(clientX, rect) {
  const { width, left } = rect;

  if (width <= 0) {
    return MIN_POSITION;
  }

  const x = clientX - left;
  const raw = (x / width) * 100;

  return clampPosition(raw);
}
